import { CardSdcItemComponent } from './partialViews/sdc-card-item.component';
import { GeneralService } from 'src/app/services/general.service';
import { Component, ElementRef, OnInit, ViewChild, AfterViewInit, ComponentFactoryResolver, ViewContainerRef, ComponentRef, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { FormularioService } from 'src/app/services/formulario.service';
import { NotificationService } from 'src/app/services/notification.service';
import { FormSec002Component } from 'src/app/views/form-sec002/form-sec002.component';
import { HttpErrorResponse } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { SelectedArea } from '../area-select.component';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-sdc-card',
    templateUrl: './sdc-card.component.html'
})

export class CardSdcComponent extends GeneralComponent implements OnInit, AfterViewInit {
    public formulario?: FormGroup;
    @ViewChild('txtCtrlSecagem') txtCtrlSecagem: ElementRef;
    @ViewChild("viewContainerRef", { read: ViewContainerRef })
    VCR: ViewContainerRef;
    child_unique_key: number = -1;
    componentsReferences = Array<ComponentRef<CardSdcItemComponent>>()
    disabledBtnRemove = true
    SelectedArea = SelectedArea

    public listSecadorBySite?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listSecadorBySiteOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public readonly minItensOnList: number = 1;
    public readonly maxItensOnList: number = 20;

    @Output() calcSdc = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(
        protected formularioService: FormularioService,
        protected formBuilder: FormBuilder,
        protected notificationService: NotificationService,
        protected generalService: GeneralService,
        private CFR: ComponentFactoryResolver) {
        super('SDC / Despalha', false);
        this.formulario = this.formBuilder.group({
            id: [null],
            controle_secagem: [null, [Validators.pattern('\^[0-9\;]+$')]],
            secador_camara: [null, [Validators.pattern('^([DGC]{1}[0-9]{1}[\\.]{1}[0-9]{2}[A-Z]?)$|([DGC]{1}[0-9]{1}[\\.][0-9]{2}[A-Z]?[;]{1})+([DGC]{1}[0-9]{1}[\\.][0-9]{2}[A-Z]?[;]?)$')]]
        });
    }

    ngAfterViewInit(): void {
        this.txtCtrlSecagem.nativeElement.focus();
    }

    public async addItem(): Promise<void> {
        this.disabledBtnRemove = false;
        this.createSdcDescargaItemComponent();
    }

    public async removeItem(): Promise<void> {
        if (!!this.componentsReferences) {
            this.componentsReferences[this.componentsReferences.length - 1].instance.remove(true);


            if (this.componentsReferences.filter(x => x.instance.btnExcluir == false).length == 0) {
                this.disabledBtnRemove = true
            }
        }
    }

    public async ngOnInit(): Promise<void> {
        this.getLists()
    }

    async getLists(): Promise<void> {
        await Promise.all([
            this.getListSecadorBySite()
        ]);
    }

    private async getListSecadorBySite(): Promise<void> {
        await this.formularioService.getListDropDownList('sec002', 'secador_camara', this.generalService.getLocalStorageDataSite()).pipe(take(1)).toPromise().then((response: any) => {
          if (!!response?.data) {
            console.log(response?.data)
            this.listSecadorBySite = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            this.listSecadorBySiteOriginal = this.listSecadorBySite;
          }
        }).catch(async (error: HttpErrorResponse) => {
          this.notificationService.showNotificationError(error, error.message);
        })
      }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public createSdcDescargaItemComponent() {

        let componentFactory = this.CFR.resolveComponentFactory(CardSdcItemComponent);
        let childComponentRef = this.VCR.createComponent(componentFactory);
        let childComponent = childComponentRef.instance;
        childComponent.unique_key = ++this.child_unique_key;
        childComponent.parentRef = this;
        this.componentsReferences.push(childComponentRef);
    }

    public removeSdcDescargaItemComponent(key: number, lastIndex) {
        console.log(key, lastIndex);

        this.VCR.remove(lastIndex ? this.VCR.length - 1 : key);
        this.componentsReferences = this.componentsReferences.filter(
            x => x.instance.unique_key !== key
        );
        this.componentsReferences.forEach((x, index) => {
            x.instance.unique_key = index
        })
        this.child_unique_key = this.componentsReferences.length - 1
    }
}

